import { Injectable } from '@angular/core';
import { ModalService } from '../modal/modal.service';

@Injectable({
  providedIn: 'root'
})
export class TelephonyService {
  constructor(private modalService: ModalService) {}

  async dialNumber(phoneNumber: string) {
    try {
      // TODO: Remove the // as they're not necessary for interpreting phone numbers: https://stackoverflow.com/questions/22704662/using-slashes-in-tel-uris.
      window.location.href = `tel://${phoneNumber}`;
    } catch (err) {
      await this.modalService.createErrorModalDialog(err);
    }
  }
}
